import React, { useEffect, useRef, useState } from "react";
import "../SearchPlayersSlider/SearchPlayersSlider.css";
import { IoIosArrowRoundForward, IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";

const SearchPlayersSlider = () => {
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const [sports, setSports] = useState([]);
  const [showAllSports, setShowAllSports] = useState(false);

  const getSports = () => {
    const url = `${APIUrl()}/v1/get_all_sports`;
    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        const data = response?.data || [];
        const formattedSports = data.map((team) => ({
          value: team?.sport_id,
          label: team?.sport_name,
        }));

        setSports(formattedSports);
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };
  useEffect(() => {
    getSports();
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollTo =
        direction === "left"
          ? scrollLeft - clientWidth / 1.5
          : scrollLeft + clientWidth / 1.5;
      scrollRef.current.scrollTo({ left: scrollTo, behavior: "smooth" });
    }
  };
  const [showEngagementModal, setShowEngagementModal] = useState(false);

  const [selectedSport, setSelectedSport] = useState(null);

  const handleFilterFanBrandAthlete = (sport) => {
    setSelectedSport(sport);
    setShowEngagementModal(true);
  };

  const handleSelectEngagement = (type) => {
    if (!selectedSport) return;

    if (type === "fan") {
      navigate("/dashboard/start-your-fan-experience", {
        state: {
          sportIdHome: selectedSport.value,
          sportLabel: selectedSport.label,
        },
      });
    } else if (type === "brand") {
      navigate("/dashboard/start-your-brand-partnership", {
        state: {
          sportIdHome: selectedSport.value,
          sportLabel: selectedSport.label,
        },
      });
    }

    setShowEngagementModal(false);
  };
  return (
    <div className="search-player-dashhead">
      <div className="search-slider-wrapper">
        <div className="search-slider-header">
          <p className="search-slider-title">SEARCH COLLEGE ATHLETES</p>
        </div>
        {!showAllSports ? (
          <div className="search-slider-container">
            <div
              className="right-left-icon-slider-search-dash"
              onClick={() => scroll("left")}
            >
              <IoIosArrowRoundBack />
            </div>

            <div className="sport-engagement-container">
              <div className="sport-scroll-wrapper" ref={scrollRef}>
                {sports.map((sport, index) => (
                  <div
                    key={index}
                    className="sport-scroll-box"
                    onClick={() => handleFilterFanBrandAthlete(sport)}
                  >
                    {sport.label}
                  </div>
                ))}
              </div>

              {/* Engagement Modal */}
            </div>

            <div
              className="right-left-icon-slider-search-dash"
              onClick={() => scroll("right")}
            >
              <IoIosArrowRoundForward />
            </div>
          </div>
        ) : null}
        {/* VIEW ALL BUTTON */}

        {showAllSports && (
          <div className="all-sports-container">
            <div className="all-sports-grid">
              {sports.map((sport, index) => (
                <div
                  key={index}
                  className="all-sports-item"
                  onClick={() => handleFilterFanBrandAthlete(sport)}
                >
                  {sport.label}
                </div>
              ))}
            </div>
          </div>
        )}

        {showEngagementModal && (
          <div className="engagement-modal-overlay">
            <div className="engagement-modal-content">
              <h3 className="engagement-modal-title">
                Select Your Engagement Type
              </h3>

              <button
                className="engagement-modal-btn engagement-modal-btn-brand"
                onClick={() => handleSelectEngagement("brand")}
              >
                Connect with Athletes and <br /> Start Your Brand Partnership
              </button>

              <button
                className="engagement-modal-btn engagement-modal-btn-fan"
                onClick={() => handleSelectEngagement("fan")}
              >
                Connect with Athletes and <br />
                Start Your Fan Experience
              </button>

              <button
                className="engagement-modal-close-btn"
                onClick={() => setShowEngagementModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="view-all-athlete-button">
        {!showAllSports ? (
          <button onClick={() => setShowAllSports(true)}>View All</button>
        ) : (
          <button
            className="all-sports-close"
            onClick={() => setShowAllSports(false)}
          >
            View Less
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchPlayersSlider;

// <div className="search-player-dashhead">
//   <div className="search-slider-wrapper">
//     <div className="search-slider-header">
//       <p className="search-slider-title">Search Athletes</p>
//     </div>
//     <div className="search-slider-container">
//       <div
//         className="right-left-icon-slider-search-dash"
//         onClick={() => scroll("left")}
//       >
//         <IoIosArrowRoundBack />
//       </div>

//       <div className="sport-engagement-container">
//         <div className="sport-scroll-wrapper" ref={scrollRef}>
//           {sports.map((sport, index) => (
//             <div
//               key={index}
//               className="sport-scroll-box"
//               onClick={() => handleFilterFanBrandAthlete(sport)}
//             >
//               {sport.label}
//             </div>
//           ))}

//         </div>

//         {/* Modal */}
//         {showEngagementModal && (
//           <div className="engagement-modal-overlay">
//             <div className="engagement-modal-content">
//               <h3 className="engagement-modal-title">
//                 Select your engagement type
//               </h3>
//               <button
//                 className="engagement-modal-btn engagement-modal-btn-brand"
//                 onClick={() => handleSelectEngagement("brand")}
//               >
//                 Connect with Athletes and Start Your Brand Partnership
//               </button>
//               <button
//                 className="engagement-modal-btn engagement-modal-btn-fan"
//                 onClick={() => handleSelectEngagement("fan")}
//               >
//                 Connect with Athletes and Start Your Fan Experience
//               </button>
//               <button
//                 className="engagement-modal-close-btn"
//                 onClick={() => setShowEngagementModal(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//       <div
//         className="right-left-icon-slider-search-dash"
//         onClick={() => scroll("right")}
//       >
//         <IoIosArrowRoundForward />
//       </div>
//     </div>
//     <div className="view-all-athlete-button">
//       <button onClick={() => setShowAllSports(true)}>View All</button>
//     </div>
//   </div>
// </div>
